import { KFShimmer, KFShimmerSkeleton } from '@kf/ic2fx';
import { Skeleton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

interface IStageTile {
  stages: {
    activityName: string;
    count: number;
  }[];
  loader: boolean;
}
const CandidateStageTile: React.FC<IStageTile> = ({ stages, loader }) => {
  return (
    <Box
      sx={{
        borderCollapse: 'collapse',
        display: 'flex',
        overflowX: { xs: 'auto', md: 'visible' },
        whiteSpace: { xs: 'nowrap', md: 'normal' },
      }}
    >
      {loader
        ? Array.from({ length: 5 }).map((stage, i) => {
            return (
              <Box
                sx={{
                  background: '#fff',
                  border: '1px solid #DDDBDA !important',
                  p: '2.5rem 1rem',
                  minHeight: '13.875rem',
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  width: { xs: '150px', md: `calc(${100 / 4}%)` },
                  margin: '-1px 0 0 -1px',
                }}
                key={`${stage}-${i}`}
                data-testid={`stage-loader-${i}`}
                id={`stage-loader-${i}`}
              >
                <Skeleton
                  variant='rectangular'
                  width='100%'
                  height='3rem'
                  animation='wave'
                  sx={{
                    mb: 1,
                    mt: 4,
                    display: 'flex',
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
                <Skeleton
                  variant='rectangular'
                  width='100%'
                  height='1.5rem'
                  animation='wave'
                  sx={{
                    mb: 2,
                    mt: 0.5,
                    display: 'flex',
                    bgcolor: (theme) => theme.palette.neutral?.main,
                  }}
                />
              </Box>
            );
          })
        : stages?.map((stage, index) => {
            return (
              <Box
                sx={{
                  background: '#fff',
                  border: '1px solid #DDDBDA',
                  p: '2.5rem 1rem',
                  minHeight: '13.875rem',
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  width: { xs: '150px', md: `calc(${100 / stages.length}%)` },
                  margin: '-1px 0 0 -1px',
                }}
                key={stage.activityName}
              >
                <Box sx={{ my: 'auto' }}>
                  <Typography
                    className='kfic2-panelTitleBold'
                    sx={{ mb: '0.5rem', color: '#080707 !important' }}
                    data-testid={`stage-count-${index}`}
                    id={`stage-count-${index}`}
                  >
                    {stage.count}
                  </Typography>
                  <Typography
                    className='kfic2-bodyTextBold'
                    data-testid={`stage-activityName-${index}`}
                    id={`stage-activityName-${index}`}
                    sx={{
                      color: '#080707 !important',
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                      textAlign: 'center',
                      maxWidth: '100%',
                    }}
                  >
                    {stage.activityName}
                  </Typography>
                </Box>
              </Box>
            );
          })}
    </Box>
  );
};

export default CandidateStageTile;
